/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface Step4Data {
  /** @maxLength 100 */
  user_role_type: string;
  /** @maxItems 20 */
  talent_priorities?: string[];
  referral_source?: string | null;
}
